/**
 * Utility functions for NPS score categorization
 */

import { NPS_COMPLETED_VALUES, type NpsCompletedValue } from "@repo/statsig";

export type ScoreCategory = NpsCompletedValue;

/**
 * Categorizes an NPS score into detractor (0-6), passive (7-8), or promoter (9-10)
 */
export function getScoreCategory(score: number): ScoreCategory {
  if (score >= 0 && score <= 6) {
    return NPS_COMPLETED_VALUES.DETRACTOR;
  }
  if (score >= 7 && score <= 8) {
    return NPS_COMPLETED_VALUES.PASSIVE;
  }
  if (score >= 9 && score <= 10) {
    return NPS_COMPLETED_VALUES.PROMOTER;
  }
  // Default fallback (shouldn't happen with valid input)
  return NPS_COMPLETED_VALUES.DETRACTOR;
}
